import React,{ useState, useEffect } from 'react';
import { useNavigate  } from 'react-router-dom';
import { Col, Select, Pagination } from 'antd';

import Star from '../Star/Star';


import './Reviews.less'

// {
//   type: 'bgCard'
//   bgImg: require('../../image/bigCardBg-3840x1440.png'),
//   contentWidth: '30%',
//   textPosition: 'right',
//   title: '线粒体能量工厂',
//   description: 'Mitopure® was developed after over a decade of scientific research. Dig deeper into the science behind a game-changing discovery for cellular health.',
//   btnConfig:{
//     text: 'Learn more',
//     link: ''
//   }
// }
const Reviews = ({reviewsData, isName}) =>{

  const ProductCategoryOptions = [
    { value: 'All', label: 'All' },
    { value: 'Nutrition', label: 'Nutrition' },
    { value: 'Skincare', label: 'Skincare' }
  ]
  const ProductsOptions = [
    { value: 'All', label: 'All' },
    { value: 'Nutrition', label: 'Nutrition' },
    { value: 'Skincare', label: 'Skincare' }
  ]
  const starOptions = [
    { value: 'All', label: 'All' },
    { value: '1', label: '1 star' },
    { value: '2', label: '2 star' },
    { value: '3', label: '3 star' },
    { value: '4', label: '4 star' },
    { value: '5', label: '5 star' }
  ]

  const [width, setWidth] = useState(window.innerWidth);
  useEffect(()=>{
    const handleResize = () => {
      setWidth(window.innerWidth);
    };
 
    // 添加事件监听器
    window.addEventListener('resize', handleResize);
 
    // 清理函数，组件卸载时移除事件监听器
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  },[])

  if(width > 770){
    return (
      <div className="Reviews-box">
        <div className="Reviews-left">
          {isName && <div style={{fontSize: 'clamp(32px, calc(27.07px + 1.31vw), 46px)'}}>Reviews</div>}
          <div style={{display:'flex', alignItems: 'flex-end'}}>
            <span style={{fontSize: 'clamp(32px, calc(27.07px + 1.31vw), 46px)',lineHeight:1}}>4.4</span>
            <span style={{margin:'0 5px'}}>/5 </span>
            <Star score={4.4}/>
          </div>
          <div style={{color: 'rgba(0,0,0,0.54)', margin:'20px 0'}}>This product is rated 4.4 out of 5 stars. We have collected more than 2821 reviews.</div>
          <div>Write a review</div>
        </div>

        <div className="Reviews-right">
          <div className="select-box">
            <Select
              className="custom-select"
              defaultValue="Product Category"
              style={{ width: 180, height: 40 }}
              options={ProductCategoryOptions}
            />
            <Select
              className="custom-select"
              defaultValue="Mitopure Softgels"
              style={{ width: 180, height: 40 }}
              options={ProductsOptions}
            />
            <Select
              className="custom-select"
              defaultValue="All ratings"
              style={{ width: 130, height: 40 }}
              options={starOptions}
            />
          </div>
          <div className="review-list">
            <div className="review-item">
              <div className="review-item-left">
                <div><Star score={5}/></div>
                <div>userName</div>
              </div>
              <div className="review-item-right">
                <div style={{fontWeight: 600}}>title</div>
                <div style={{margin: '15px 0'}}>description</div>
                <div style={{margin: '15px 0'}}>img|video</div>
                <div>Show more</div>
              </div>
            </div>
            <div className="review-item">
              <div className="review-item-left">
                <div><Star score={5}/></div>
                <div>userName</div>
              </div>
              <div className="review-item-right">
                <div style={{fontWeight: 600}}>title</div>
                <div style={{margin: '15px 0'}}>description</div>
                <div style={{margin: '15px 0'}}>img|video</div>
                <div>Show more</div>
              </div>
            </div>
            <div className="review-item">
              <div className="review-item-left">
                <div><Star score={5}/></div>
                <div>userName</div>
              </div>
              <div className="review-item-right">
                <div style={{fontWeight: 600}}>title</div>
                <div style={{margin: '15px 0'}}>description</div>
                <div style={{margin: '15px 0'}}>img|video</div>
                <div>Show more</div>
              </div>
            </div>
          </div>
          <div className="pagination-box">
            <Pagination align="center" defaultCurrent={1} total={500} showSizeChanger={false}/>
          </div>
        </div>
      </div>
    )
  }else{
    return (
      <div className="Reviews-box-phone" style={{padding:'0 25px',display:'block'}}>
        <div className="Reviews-left" style={{width: '100%',position: 'relative'}}>
          {isName && <div style={{fontSize: 'clamp(32px, calc(27.07px + 1.31vw), 46px)'}}>Reviews</div>}
          <div style={{display:'flex', alignItems: 'flex-end'}}>
            <span style={{fontSize: 'clamp(32px, calc(27.07px + 1.31vw), 46px)',lineHeight:1}}>4.4</span>
            <span style={{margin:'0 5px'}}>/5 </span>
            <Star score={4.4}/>
          </div>
          <div style={{color: 'rgba(0,0,0,0.54)', margin:'20px 0'}}>This product is rated 4.4 out of 5 stars. We have collected more than 2821 reviews.</div>
          <div>Write a review</div>
        </div>

        <div className="Reviews-right" style={{width: '100%'}}>
          <div style={{width:'100%', marginTop: 30, overflowX:'auto'}}>
            <div className="select-box" style={{width:'180%'}}>
              <Select
                className="custom-select"
                defaultValue="Product Category"
                style={{ width: 180, height: 40 }}
                options={ProductCategoryOptions}
              />
              <Select
                className="custom-select"
                defaultValue="Mitopure Softgels"
                style={{ width: 180, height: 40 }}
                options={ProductsOptions}
              />
              <Select
                className="custom-select"
                defaultValue="All ratings"
                style={{ width: 130, height: 40 }}
                options={starOptions}
              />
            </div>
          </div>
          <div className="review-list">
            <div className="review-item">
              <div className="review-item-left">
                <div><Star score={5}/></div>
                <div>userName</div>
              </div>
              <div className="review-item-right">
                <div style={{fontWeight: 600}}>title</div>
                <div style={{margin: '15px 0'}}>description</div>
                <div style={{margin: '15px 0'}}>img|video</div>
                <div>Show more</div>
              </div>
            </div>
            <div className="review-item">
              <div className="review-item-left">
                <div><Star score={5}/></div>
                <div>userName</div>
              </div>
              <div className="review-item-right">
                <div style={{fontWeight: 600}}>title</div>
                <div style={{margin: '15px 0'}}>description</div>
                <div style={{margin: '15px 0'}}>img|video</div>
                <div>Show more</div>
              </div>
            </div>
            <div className="review-item">
              <div className="review-item-left">
                <div><Star score={5}/></div>
                <div>userName</div>
              </div>
              <div className="review-item-right">
                <div style={{fontWeight: 600}}>title</div>
                <div style={{margin: '15px 0'}}>description</div>
                <div style={{margin: '15px 0'}}>img|video</div>
                <div>Show more</div>
              </div>
            </div>
          </div>
          <div className="pagination-box">
            <Pagination align="center" defaultCurrent={1} total={500} showSizeChanger={false}/>
          </div>
        </div>
      </div>
    )
  }
}

export default Reviews